import React from 'react'
import { Button, useTheme } from '@material-ui/core'
import { alpha, styled } from '@material-ui/core/styles'
import BiotechIcon from '@mui/icons-material/Biotech'
import ScienceIcon from '@mui/icons-material/Science'
import ViewListIcon from '@mui/icons-material/ViewList'
import LocalHospitalIcon from '@mui/icons-material/LocalHospital'

const QuickAccessBarContainer = styled('div')(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  backgroundColor: theme.palette.background.paper,
  padding: theme.spacing(1),
  gap: theme.spacing(2), // This will now properly create spacing between buttons
}))

const QuickAccessButton = styled(Button)(({ theme }) => ({
  minWidth: 100,
  width: 'auto',
  margin: 0,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: theme.spacing(0.5),
  padding: theme.spacing(1, 1.5),
  borderRadius: theme.spacing(1),
  backgroundColor: alpha(theme.palette.text.primary, 0.05),
  fontSize: '0.85rem',
  textTransform: 'none',
  whiteSpace: 'nowrap',

  '&:hover': {
    backgroundColor: alpha(theme.palette.text.primary, 0.09),
  },
}))

export default function QuickAccessBar({
  isDarkMode,
  onHPOButtonClick,
  onDiseaseButtonClick,
  onSamplesButtonClick,
  onPanelsButtonClick,
}) {
  const theme = useTheme()

  return (
    <QuickAccessBarContainer theme={theme} isDarkMode={isDarkMode}>
      <QuickAccessButton
        theme={theme}
        isDarkMode={isDarkMode}
        startIcon={<LocalHospitalIcon />}
        onClick={onHPOButtonClick}
      >
        HPO
      </QuickAccessButton>
      <QuickAccessButton
        theme={theme}
        isDarkMode={isDarkMode}
        startIcon={<ScienceIcon />}
        onClick={onDiseaseButtonClick}
      >
        Diseases
      </QuickAccessButton>
      <QuickAccessButton
        theme={theme}
        isDarkMode={isDarkMode}
        startIcon={<ViewListIcon />}
        onClick={onSamplesButtonClick}
      >
        Samples
      </QuickAccessButton>
      <QuickAccessButton
        theme={theme}
        isDarkMode={isDarkMode}
        startIcon={<BiotechIcon />}
        onClick={onPanelsButtonClick}
      >
        Panels
      </QuickAccessButton>
    </QuickAccessBarContainer>
  )
}
